export const isNumber = (value?: string | string[] | number): boolean => {
  return Boolean(
    value !== null && value !== undefined && value !== '' && !Number.isNaN(Number(value)),
  );
};
